<template>
  <div v-if="show" class="tips-story-layer">
    <div class="tips-story-timer-pop" v-if="timer.show">
      <div class="tips-story-timer">
        <span>{{timer.time}}</span>
      </div>
    </div>
    <div class="tipsstory-message-list">
      <div class="d-flex justify-space-between w-100">
        <div class="tipsstory-message-question">
          <span v-if="question">
            <v-btn fab x-small color="purple darken-1">Q</v-btn>
            {{question}}
          </span>
        </div>
        <div class="tipsstory-message-author">
          <span>{{teller}}</span>
          <span class="tips-teller-icon"></span>
        </div>
      </div>
      <div class="tipsstory-message-boxs" v-if="contents">
        <div
          v-for="(content,i) in contents"
          class="tipsstory-message-box"
          :key="i"
          v-text="content"
        />
      </div>
      <transition name="fade">
        <div class="tipsstory-message-boxs text-left" v-if="tipState && tipState.message">
          <div
            class="tipsstory-message-box"
            v-text="tipState.message"
          />
        </div>
      </transition>
    </div>
    <div class="tipsstory-warning">
      <span class="tipsstory-wraning-icon"></span>
      <span>{{warning}}</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-async-in-computed-properties */
/* eslint-disable vue/no-side-effects-in-computed-properties */
import Message from '@/lib/Message'
import * as validator from '@/lib/validator'
export default {
  props: {
    target: {
      type: Message,
      default: null
    },
    teller: {
      validator: validator.nullableString(),
      default: null
    },
    question: {
      validator: validator.nullableString(),
      default: null
    },
    contents: {
      type: Array,
      required: true
    },
    warningMessage: {
      type: validator.nullableString(),
      default: null
    },
    show: {
      type: Boolean,
      required: true
    }
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  computed: {
    tipState(){
      let msg = this.target
      if(this.target){
        console.log('tipState', this.target, this.target.data.tips)
      }
      // if(this.$tt){
      //   clearInterval(this.$tt)
      // }
      // this.$tt = setInterval(()=>{
      //   this.$set(msg.data, 'tips', msg.data.tips)
      //   console.log('$tt', this.target, this.target.data.tips, this.tipState)
      // }, 1000)
      if(this.target && this.target.data.tips){
        return this.target.data.tips
      }
      return null
    },
    warning(){
      return this.warningMessage || '關鍵場景將會影響故事走向，要謹慎回答唷！'
    }
  },
  data(){
    return {
      timer: {
        show: false,
        time: 59
      }
    }
  },
  mounted(){
  },
  beforeDestroy(){
    if(this.$tt){
      clearInterval(this.$tt)
    }
  },
  methods: {
    /**
     * call from outer component
     * 開始倒數計時
     */
    startTimer(second){
      if(!this.$timer){
        let t = new Date().getTime() + (second * 1000)
        this.$timer = setTimeout(()=>{
          this.timer.time = (t - new Date().getTime()) / 1000
          if(this.$timer && this.timer.time <= 0){
            clearInterval(this.$timer)
            this.$emit('timer-timeout')
          }
        }, 500)
      }
    },
    /**
     * call from outer component
     * 停止倒數計時
     */
    stopTimer(){
      if(this.$timer){
        clearInterval(this.$timer)
        this.$emit('timer-stop')
      }
      return !!this.$timer
    }
  }
}
</script>

<style scoped>
  @import '../../style/game.css';
  .w-100{
    width: 100%;
  }
</style>
